const { expect } = require('chai');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

const entryIdsWithStatus = (entryIds, status) =>
  Object.values(entryIds)
    .map((entryId) => Object.values(entryId))
    .flat()
    .map((entryId) => entryId.migratortronTarget)
    .map((entryId) => Object.values(entryId))
    .flat()
    .filter((entryId) => entryId.status === status);

describe('Partial entries update', () => {
  describe('preview creating a partial single entry that does not exist', () => {
    const mock = loadRecordedMock(
      'migrate_entries_partial_create_preview.json'
    );

    it(`should return one entry`, (done) => {
      migratortronApi.post(
        'migrate/entries?partial&create',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;
          expect(body?.entries?.migratortron?.totalCount).to.equal(1);
          expect(
            entryIdsWithStatus(body.entriesToMigrate.entryIds, 'create')
          ).to.have.a.lengthOf(1);
          done();
        }
      );
    });
  });

  describe('create a partial single entry that does not exist', () => {
    const mock = loadRecordedMock('migrate_entries_commit_partial_create.json');

    it(`should create one entry`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?partial&create',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(body?.entries?.migratortron?.totalCount).to.equal(1);
          expect(body?.migrateResult.created).to.equal(1);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('repeat the same create a partial single entry that does not exist', () => {
    const mock = loadRecordedMock(
      'migrate_entries_commit_partial_create_repeat.json'
    );

    it(`should return one entry`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?partial&create&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(body?.entries.migratortron.totalCount).to.equal(1);
          expect(body?.existing.migratortronTarget.totalCount).to.equal(1);
          expect(body?.entriesToMigrate.migratortronTarget.totalCount).to.equal(
            0
          );

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview updating a partial single entry', () => {
    const mock = loadRecordedMock('migrate_entries_partial_preview.json');

    it(`should return one entry`, (done) => {
      migratortronApi.post(
        'migrate/entries?partial',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;
          expect(body?.entries?.migratortron?.totalCount).to.equal(1);
          expect(
            entryIdsWithStatus(body.entriesToMigrate.entryIds, 'update')
          ).to.have.a.lengthOf(1);
          done();
        }
      );
    });
  });

  describe('update a partial single entry', () => {
    const mock = loadRecordedMock('migrate_entries_commit_partial.json');

    it(`should update one entry`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?partial',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(body?.entries?.migratortron?.totalCount).to.equal(1);
          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(1);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('repeat the same update a partial single entry', () => {
    const mock = loadRecordedMock('migrate_entries_commit_partial_repeat.json');

    it(`should return one entry`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?partial&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(body?.entries.migratortron.totalCount).to.equal(1);
          expect(body?.existing.migratortronTarget.totalCount).to.equal(1);
          expect(body?.entriesToMigrate.migratortronTarget.totalCount).to.equal(
            0
          );

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });
});
